import React from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";

// Animations
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(83, 80, 81, 0.7);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(255, 0, 100, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 100, 0);
  }
`;

const flicker = keyframes`
  0%, 19%, 21%, 23%, 25%, 54%, 56%, 100% {
    opacity: 1;
  }
  20%, 22%, 24%, 55% {
    opacity: 0.5;
  }
`;

// Styled Components
const RestrictedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: #000;
  color: white;
  text-align: center;
`;

const ErrorTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  background: linear-gradient(90deg, rgb(44, 44, 44), rgb(44, 42, 42));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  letter-spacing: 2px;
  animation: ${flicker} 3s infinite;
`;

const ErrorMessage = styled.p`
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 700px;
  line-height: 1.6;
`;

const HomeButton = styled.button`
  background: linear-gradient(45deg, rgb(92, 87, 87), rgb(92, 86, 86));
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  color: white;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 1px;
  animation: ${pulse} 2s infinite;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transform: translateX(-100%);
    transition: transform 0.6s ease;
  }

  &:hover::after {
    transform: translateX(100%);
  }
`;

const ErrorIcon = styled.div`
  font-size: 5rem;
  margin-bottom: 2rem;
  color: rgb(192, 172, 172);
  text-shadow: 0 0 10px rgba(73, 63, 63, 0.5);
`;

const RestrictedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <RestrictedWrapper>
      <ErrorIcon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </ErrorIcon>

      <ErrorTitle>Access Denied</ErrorTitle>

      <ErrorMessage>Authentication failure.</ErrorMessage>

      <HomeButton onClick={() => navigate("/")}>Return to Main Hub</HomeButton>
    </RestrictedWrapper>
  );
};

export default RestrictedPage;
